import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, EMPTY, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BffService } from './BffService';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private bff: BffService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Skip token attachment for authentication endpoints
        if (req.url.includes('/login') || req.url.includes('/register') || req.url.includes('/oauth2') || req.url.includes('/refresh-token')) {
            return next.handle(req);
        }

        // BFF mode: rely on cookie-based auth and send credentials
        if (environment.authMode === 'bff') {
            // Include CSRF header for state-changing requests
            let headers: { [k: string]: string } = {};
            const needsCsrf = req.method === 'POST' || req.method === 'PUT' || req.method === 'PATCH' || req.method === 'DELETE';
            if (needsCsrf) {
                const token = this.bff.getCsrfToken() || this.readCookie('XSRF-TOKEN');
                if (token) headers['X-CSRF-TOKEN'] = token;
            }
            const reqWithCreds = req.clone({ withCredentials: true, setHeaders: headers });
            return next.handle(reqWithCreds);
        }

        // No MSAL path remaining
        return next.handle(req);
    }

    private readCookie(name: string): string | null {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
}
